import { type ComponentPropsWithoutRef, memo } from 'react';

import { Command } from '@air/cmdk';
import { cn } from '@air/utils-tailwind';

export type SearchCommandGroupProps = ComponentPropsWithoutRef<typeof Command.Group>;

export const SearchCommandGroup = memo(({ className, ...restOfProps }: SearchCommandGroupProps) => {
  return (
    <Command.Group
      className={cn(
        'mb-3 flex shrink-0 flex-col gap-1 last:mb-0 only:mb-0 [&[hidden]]:hidden [&_[cmdk-group-heading]]:flex [&_[cmdk-group-heading]]:h-4 [&_[cmdk-group-heading]]:items-center [&_[cmdk-group-heading]]:px-1 [&_[cmdk-group-heading]]:font-bold [&_[cmdk-group-heading]]:text-10 [&_[cmdk-group-heading]]:text-grey-9 [&_[cmdk-group-heading]]:uppercase [&_[cmdk-group-heading]]:tracking-[0.4px]',
        className,
      )}
      data-testid="SEARCH_COMMAND_GROUP"
      {...restOfProps}
    />
  );
});

SearchCommandGroup.displayName = 'SearchCommandGroup';
